import { render } from "./SidebarNav.vue?vue&type=template&id=a9714d9e"
import script from "./SidebarNav.vue?vue&type=script&lang=ts"
export * from "./SidebarNav.vue?vue&type=script&lang=ts"
script.render = render

export default script